'use client'

import { Suspense } from 'react'
import { scriptConfigs } from '@/config/scriptConfigs'

import GclidTracker from '@/components/analytics/GclidTracker'
import OptimizedScriptLoader from '@/scripts/OptimizedScriptLoader'

/** Client-only shell: analytics capture + deferred third-party scripts. */
const LayoutClientEffects = () => {
  return (
    <>
      <Suspense fallback={null}>
        <GclidTracker />
      </Suspense>
      <OptimizedScriptLoader scripts={scriptConfigs} />
    </>
  )
}

export default LayoutClientEffects
